// extracted by mini-css-extract-plugin
export default {"container":"KP-z","timeTop":"LP-z","timeCountdown":"MP-z","cta":"NP-z","disabled":"OP-z","product":"PP-z"};